module.exports = __webpack_public_path__ + "fonts/AvenirNextCyr-Medium.6d6cd98d.eot";